import { Modal, Pressable, StyleSheet, View } from "react-native";
import React, { useContext } from "react";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { PlaceColors } from "../helpers/PlaceColors";
import Toast from "react-native-toast-message";
import { FindifyToastConfig } from "./FindifyToast";

type FindifyBasicModalProps = {
    children: JSX.Element;
    isOpen: boolean;
    closeModal: () => void;
    transparent?: boolean;
    align?: 'flex-start' | 'center' | 'flex-end';
    style?: any;
}

export const FindifyBasicModal = ({
    isOpen,
    closeModal,
    children,
    align,
    transparent,
    style,
}: FindifyBasicModalProps) => {
    const findifyDataContext = useContext(FindifyDataContext);
    return <Modal
        animationType="fade"
        transparent={true}
        visible={isOpen}
        onRequestClose={closeModal}
    >
        <Pressable
            style={[modalStyle.modal, { justifyContent: align ?? 'center' }]}
            onPress={closeModal}>
            {/* this is needed so that the modal doesn't close */}
            <Pressable onPress={(ev) => { }}>
                <View style={[modalStyle.modalView, { backgroundColor: transparent ? 'transparent' : PlaceColors(findifyDataContext).background.get(), ...StyleSheet.flatten(style ?? {}) }]} >
                    {children}
                </View>
            </Pressable>
        </Pressable>
        <Toast config={FindifyToastConfig} />
    </Modal>
}



const modalStyle = StyleSheet.create({
    modal:
    {
        backgroundColor: '#00000080',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    modalView: {
        borderRadius: 10,
        maxHeight: '90%',
        alignItems: 'center',
        shadowColor: '#000',
    },
})
